module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cmslist"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": "/indexpc"
    }
  }, [_c('a', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("童演招募")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [_c('el-input', {
    staticClass: "container_right_search",
    attrs: {
      "placeholder": "请输入姓名",
      "clearable": "",
      "prefix-icon": "el-icon-search"
    },
    nativeOn: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchFun($event)
      }
    },
    model: {
      value: (_vm.searchdata),
      callback: function($$v) {
        _vm.searchdata = $$v
      },
      expression: "searchdata"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "foruse_btn",
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/tongyan-apply-index'
        })
      }
    }
  }, [_vm._v("我要申报")]), _vm._v(" "), (_vm.newsListData.length) ? _c('div', {
    staticClass: "list_arr"
  }, _vm._l((_vm.newsListData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list_arr_item",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'CuteSinglePage',
            query: {
              id: item.id
            }
          })
        }
      }
    }, [_c('img', {
      staticClass: "list_arr_item_img",
      attrs: {
        "src": item.pics && item.pics.length ? item.pics[0].url : ''
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "list_arr_item_right"
    }, [_c('div', {
      staticClass: "list_arr_item_right_namecity"
    }, [_c('div', {
      staticClass: "list_arr_item_right_namecity_name"
    }, [_vm._v(_vm._s(item.ldname))]), _vm._v(" "), _c('div', {
      staticClass: "list_arr_item_right_namecity_site"
    }, [_vm._v(_vm._s(item.province))])]), _vm._v(" "), _c('div', {
      staticClass: "list_arr_item_right_tips"
    }, [_c('div', {
      staticClass: "list_arr_item_right_tip"
    }, [_c('p', [_vm._v("生日:" + _vm._s(item.age ? item.age : 0))])]), _vm._v(" "), _c('div', {
      staticClass: "list_arr_item_right_tip"
    }, [_c('p', [_vm._v("身高:" + _vm._s(item.height ? item.height : 0) + "cm")])]), _vm._v(" "), _c('div', {
      staticClass: "list_arr_item_right_tip"
    }, [_c('p', [_vm._v("体重:" + _vm._s(item.weight ? item.weight : 0) + "kg")])]), _vm._v(" "), _c('div', {
      staticClass: "list_arr_item_right_tip"
    }, [_c('p', [_vm._v("鞋码:" + _vm._s(item.shoesize ? item.shoesize : 0))])])])]), _vm._v(" "), (item.grade && false) ? _c('div', {
      staticClass: "list_arr_item_tag"
    }, [_vm._v(_vm._s(item.grade))]) : _vm._e()])
  }), 0) : _c('img', {
    staticClass: "list_empty_img_class",
    attrs: {
      "src": require("@/assets/images/listitem/course_constuct.png")
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container_right"
  }, [_c('CmsCrew')], 1)])], 1), _vm._v(" "), _c('DeBounce', {
    attrs: {
      "fetch-fun": _vm.getTalentListFun,
      "pagefetchflag": _vm.pagefetchflag
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6890536c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/TalentList.vue
// module id = 1268
// module chunks = 0